import CuratedEmojiPicker from "components/common/CuratedEmojiPicker";

export type ExcursionClientEmojiPickerProps = {
  value: string | null | undefined;
  onChange: (emoji: string | undefined) => void;
  disabled?: boolean;
  ariaLabel?: string;
  menuZIndex?: number;
};

export default function ExcursionClientEmojiPicker({
  value,
  onChange,
  disabled,
  ariaLabel = "Indicateur client",
  menuZIndex = 2200,
}: ExcursionClientEmojiPickerProps) {
  return (
    <CuratedEmojiPicker
      selected={value}
      onPick={(emoji) => onChange(emoji)}
      disabled={disabled}
      ariaLabel={ariaLabel}
      menuZIndex={menuZIndex}
      triggerLabel={value?.trim() ? value.trim() : "·"}
      triggerSizePx={22}
    />
  );
}
